import { render, staticRenderFns } from "./VirtualVisits.vue?vue&type=template&id=42dd7987"
import script from "./VirtualVisits.vue?vue&type=script&lang=js"
export * from "./VirtualVisits.vue?vue&type=script&lang=js"
import style0 from "./VirtualVisits.vue?vue&type=style&index=0&id=42dd7987&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports